import React from 'react';
import { PromotionalBadge } from '@honeycomb/data';
import { mapCMSBackgroundColorToThemeColor, mapCMSTextColorToThemeColor } from '@honeycomb/ui';
import { ColorOption, Styler, StylerProps, TypographyHero } from '@honeycomb/ui-core';

export interface TrRoundelBadgeProps extends StylerProps {
    badge: PromotionalBadge;
}

export function TrRoundelBadge(props: TrRoundelBadgeProps): React.JSX.Element {
    const { badge, ...other } = props;
    const { text, backgroundColor: backgroundColorProp, textColor: textColorProp } = badge;

    // Colour mappings
    const backgroundColor: ColorOption = backgroundColorProp
        ? mapCMSBackgroundColorToThemeColor(backgroundColorProp)
        : 'background.content';

    const textColor: ColorOption = textColorProp ? mapCMSTextColorToThemeColor(textColorProp) : 'text.body';

    return (
        <Styler
            w={100}
            h={100}
            br="100%"
            p={2}
            bg={backgroundColor}
            c={textColor}
            display="flex"
            justifyContent="center"
            alignItems="center"
            {...other}
        >
            <TypographyHero weight="bold" ta="center" size="xs">
                {text}
            </TypographyHero>
        </Styler>
    );
}
